// - SYSTEM-WIDE TOGGLES - //
	// import "js/sys-toggles.js"

// - CSS ROOT- //
	import "./2-css/index.styl";

// - JS IMPORTS - //
	import "./3-js/modal-toggle.js";
	import "./3-js/modal-link-attach.js";
	import "./3-js/anchor-link-smooth-scrolling.js";

// ANCHOR LINKS SMOOTH SCROLLING


// - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
// HMR
	if (module.hot) {
		module.hot.accept(function(err) {
			console.log(err)
		})
	}

